var _defs, _circle, _path, _g, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reuse-0",
    fill: "#fff",
    d: "M14.468 13.333a.668.668 0 0 0-1.303.295l1.42 6.278a.668.668 0 0 0 1.303-.295l-1.42-6.278Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-1",
    fill: "#fff",
    d: "M23.939 13.333a.668.668 0 0 1 1.303.295l-1.42 6.278a.668.668 0 0 1-1.303-.295l1.42-6.278Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-2",
    fill: "#fff",
    d: "M18.362 13.316c0-.35.3-.634.668-.634.37 0 .669.284.669.634v6.348c0 .35-.3.634-.669.634-.369 0-.668-.284-.668-.634v-6.348Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E95D1D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 25,
    height: 25,
    x: 5,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.053 7.022H5v24.053h24.053V7.022Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.345 12.682h18.04l-3.341 9.353H13.017l-2.672-9.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.75 22.57h12.78a.704.704 0 0 0 .677-.51l2.82-9.866a.706.706 0 0 0-.677-.898H11.124l-.504-2.267a.705.705 0 0 0-.687-.552H5.706a.705.705 0 0 0 0 1.41h3.663l2.544 11.448a2.117 2.117 0 0 0-1.274 1.94c0 1.165.948 2.113 2.114 2.113H25.53a.705.705 0 0 0 0-1.41H12.753a.705.705 0 0 1-.002-1.408h-.001Zm14.664-9.865-2.416 8.457H13.316l-1.879-8.457h15.977ZM12.044 27.505c0 1.166.948 2.114 2.114 2.114a2.116 2.116 0 0 0 2.113-2.114 2.116 2.116 0 0 0-2.113-2.113 2.116 2.116 0 0 0-2.114 2.113Zm2.115-.704a.705.705 0 1 1-.001 1.41.705.705 0 0 1 0-1.41ZM22.008 27.505c0 1.166.948 2.114 2.114 2.114a2.116 2.116 0 0 0 2.113-2.114 2.116 2.116 0 0 0-2.113-2.113 2.116 2.116 0 0 0-2.114 2.113Zm2.114-.704a.705.705 0 1 1 0 1.41.705.705 0 0 1 0-1.41Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E95D1D",
    d: "M14.468 13.333a.668.668 0 0 0-1.303.295l1.42 6.278a.668.668 0 0 0 1.303-.295l-1.42-6.278Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E95D1D",
    d: "M23.939 13.333a.668.668 0 0 1 1.303.295l-1.42 6.278a.668.668 0 0 1-1.303-.295l1.42-6.278Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E95D1D",
    d: "M18.362 13.316c0-.35.3-.634.668-.634.37 0 .669.284.669.634v6.348c0 .35-.3.634-.669.634-.369 0-.668-.284-.668-.634v-6.348Z"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 6h24.053v25.389H5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.27bd0045e0f2a575cd9a75a6a05c8f54.svg";
export { ForwardRef as ReactComponent };